import { Button, Flex, FormControl, Text } from '@chakra-ui/react';
import { useFormikContext } from 'formik';
import { Toggle } from 'components';
import { okayWithArray } from 'utils';

const OkayWith = ({
  next,
  prev,
}: {
  next: () => void;
  prev: () => void;
}): JSX.Element => {
  const {
    values: { okayWith },
    setFieldValue,
    handleBlur,
  } = useFormikContext<ApplicationQuestionsValues>();

  return (
    <Flex direction="column" width="100%">
      <Flex direction="column" bg="custom.levoAlabaster" py="61.5px" px={6}>
        <Text textStyle="heading3" fontWeight="bold">
          Are you ok with
        </Text>
        <FormControl id="okayWith" display="flex" flexDirection="column" mt={6}>
          {okayWithArray.map(({ id, key, value }) => (
            <Flex
              key={`okay-with-${id}`}
              direction="row"
              justifyContent="space-between"
              _notLast={{ mb: 4 }}
            >
              <Text>{value}</Text>
              <Toggle
                isChecked={!!okayWith[key]}
                onChange={(event) => {
                  const newOkayWith = {
                    ...okayWith,
                    [key]: event.target.checked,
                  };
                  setFieldValue('okayWith', newOkayWith);
                }}
                onBlur={handleBlur}
              />
            </Flex>
          ))}
        </FormControl>
      </Flex>
      <Flex width="100%" justifyContent="space-between" mt={6}>
        <Button
          width="fit-content"
          height="fit-content"
          bg="custom.levoDarkSnow"
          borderRadius="8px"
          mt={6}
          py={4}
          px={6}
          onClick={prev}
        >
          <Text textStyle="body" fontWeight={700} color="custom.levoBlue">
            Back
          </Text>
        </Button>
        <Button
          width="fit-content"
          height="fit-content"
          bg="custom.levoBlue"
          borderRadius="8px"
          mt={6}
          py={4}
          px={6}
          onClick={next}
        >
          <Text textStyle="body" fontWeight={700} color="white">
            Next
          </Text>
        </Button>
      </Flex>
    </Flex>
  );
};

export default OkayWith;
